import React from 'react';

import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { IconExternalLink } from '@lightspeed/flame/Icon/ExternalLink';

import { createReactRenderer } from 'helpers/react-renderer';

const StyledButton = styled(Button)`
  margin: 0 6px 6px;
  span {
    padding: 0 !important;
  }
`;

const PublishToEcomButtons = ({ isEnabled, detailsLink, storeLink }) => (
  <div className="cirrus cr-pt-1 cr-flex cr-flex-wrap">
    <StyledButton
      href={isEnabled ? detailsLink : ''}
      target="_blank"
      variant={isEnabled ? 'secondary' : 'neutral'}
      disabled={!isEnabled}
    >
      Manage Online Details
      <IconExternalLink color={isEnabled ? 'blue' : 'gray'} />
    </StyledButton>

    <StyledButton
      href={isEnabled ? storeLink : ''}
      target="_blank"
      variant={isEnabled ? 'secondary' : 'neutral'}
      disabled={!isEnabled}
    >
      View in Online Store
      <IconExternalLink color={isEnabled ? 'blue' : 'gray'} />
    </StyledButton>
  </div>
);

const RenderedComponent = createReactRenderer({
  component: PublishToEcomButtons,
  selector: '[data-react-root="PublishToEcomButtons"]',
});

history.onChangeState(
  { name: ['item.views.item', 'item.views.quick_add'], tab: 'details', id: undefined },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default PublishToEcomButtons;
